import styled from '@emotion/styled';
import { screenSizes } from '../Literals';

export const NewGroupFormContainer = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  box-sizing: border-box;

  .new-group-form__toggles {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.25rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .selectorCheck {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem 1rem;
    width: 100%;
    margin: 0;

    label {
      cursor: pointer;
      padding: 0 0.5rem;
      margin: 0;
    }

    label.active-label {
      font-weight: 600;
    }
  }

  .ccf-form__section {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding-top: 0.5rem;
  }

  .ccf-form__section h3 {
    margin: 0.25rem 0 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #2c3e50;
  }

  .ccf-form__section > label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.15rem;
    font-size: 0.9rem;
    color: #333;
  }

  .ccf-form__leader-fields {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem 1.25rem;
  }

  @media only screen and (max-width: ${screenSizes.tablet}) {
    .ccf-form__leader-fields {
      grid-template-columns: 1fr;
    }
  }

  .ccf-form__observations #transversal,
  .ccf-form__observations textarea {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box;
  }
`;
